import { iframeDataBridge } from '../iframe/iframeDataBridge';

const _missingKey = [];

function getLocalLanguage() {
	const externis = iframeDataBridge.getExternis();
	return externis?.languageVM?.language?.() || 'fr-FR';
}

function lowerTrim(str) {
	return (str || '').toString().toLowerCase().trim();
}

export function useTranslator() {
	return function translate(text) {
		if (!text) return '';

		let locale = null;
		const lang = getLocalLanguage();
		const externis = iframeDataBridge.getExternis();

		const appRes = externis?.applicationResources?.[lang] || [];
		locale = appRes.find((t) => lowerTrim(t.name) === lowerTrim('W-' + text));
		locale = locale ? locale.value : null;

		if (!locale) {
			const fallback = appRes.find((t) => lowerTrim(t.name) === lowerTrim(text));
			locale = fallback ? fallback.value : null;
		}

		try {
			const hashed = text.hashCode?.() ?? fallbackHash(text);
			const translations = externis?.translations?.[lang] || {};
			if (!translations[hashed] && !locale && !_missingKey.includes(text)) {
				_missingKey.push(text);
			}
			return locale || translations[hashed] || text + '*';
		} catch (e) {
			return text + '*';
		}
	};
}

function fallbackHash(str) {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const chr = str.charCodeAt(i);
		hash = (hash << 5) - hash + chr;
		hash |= 0;
	}
	return hash;
}
